import React from "react";
import styles from "../../styles/styles";

const brands = [
  { src: "https://logos-world.net/wp-content/uploads/2020/04/Sony-Logo.png", alt: "Sony" },
  { src: "https://logos-world.net/wp-content/uploads/2020/08/Dell-Logo-1989-2016.png", alt: "Dell" },
  { src: "https://www.vectorlogo.zone/logos/lg/lg-ar21~bgwhite.svg", alt: "LG" },
  { src: "https://www.vectorlogo.zone/logos/apple/apple-ar21~bgwhite.svg", alt: "Apple" },
  { src: "https://cdn-icons-png.flaticon.com/512/888/888879.png", alt: "Brand" },
];

const Sponsored = () => {
    return (
        <div className={`${styles.section} hidden sm:block bg-gradient-to-br from-[#F5F8FF] to-[#A0C1FF] py-10 px-5 mb-12 rounded-3xl shadow-lg overflow-hidden`}>
            <div className="relative flex overflow-x-hidden">
                {/* First set */}
                <div className="flex gap-8 items-center py-2 animate-marquee whitespace-nowrap">
                    {brands.map((brand, idx) => (
                        <img
                            key={`a-${idx}`}
                            src={brand.src}
                            alt={brand.alt}
                            className="w-[120px] h-16 object-contain rounded-xl shadow-md bg-white p-2"
                        />
                    ))}
                </div>
                {/* Duplicate set for seamless loop */}
                <div className="flex gap-8 items-center py-2 animate-marquee2 whitespace-nowrap absolute top-0" style={{ left: "100%" }}>
                    {brands.map((brand, idx) => (
                        <img
                            key={`b-${idx}`}
                            src={brand.src}
                            alt={brand.alt}
                            className="w-[120px] h-16 object-contain rounded-xl shadow-md bg-white p-2"
                        />
                    ))}
                </div>
            </div>
            <style>{`
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-100%); }
                }
                @keyframes marquee2 {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-100%); }
                }
                .animate-marquee {
                    animation: marquee 20s linear infinite;
                }
                .animate-marquee2 {
                    animation: marquee2 20s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default Sponsored;
